"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var objectAccess_exports = {};
__export(objectAccess_exports, {
  ACCESS_ROOT_FIELD: () => ACCESS_ROOT_FIELD,
  ACCESS_ROOT_PROJECTION: () => ACCESS_ROOT_PROJECTION,
  DEFAULT_ACCESS_PARENT: () => DEFAULT_ACCESS_PARENT,
  audienceToVisibility: () => audienceToVisibility,
  getAccessAudience: () => getAccessAudience,
  getAccessMembers: () => getAccessMembers,
  getAccessOwners: () => getAccessOwners,
  getAccessParents: () => getAccessParents,
  getAccessPolicyClasses: () => getAccessPolicyClasses,
  getAccessReaders: () => getAccessReaders,
  getAccessRoot: () => getAccessRoot,
  getClassAccessPolicy: () => getClassAccessPolicy,
  getObjectAccessReaders: () => getObjectAccessReaders,
  isAccessAudience: () => isAccessAudience,
  resetAccessPolicyClasses: () => resetAccessPolicyClasses,
  touchesAttribute: () => touchesAttribute,
  visibilityToAudience: () => visibilityToAudience
});
module.exports = __toCommonJS(objectAccess_exports);
var import_component = __toESM(require("./component"));
const ACCESS_ROOT_FIELD = "accessRoot";
const DEFAULT_ACCESS_PARENT = { field: "attachedTo", classField: "attachedToClass" };
function visibilityToAudience(visibility) {
  switch (visibility) {
    case "public":
      return { kind: "space" };
    case "participants":
      return { kind: "parentParticipants" };
    case "private":
      return { kind: "members" };
  }
}
__name(visibilityToAudience, "visibilityToAudience");
function audienceToVisibility(audience) {
  switch (audience?.kind) {
    case "parentParticipants":
      return "participants";
    case "members":
      return "private";
    default:
      return "public";
  }
}
__name(audienceToVisibility, "audienceToVisibility");
function isAccessAudience(value) {
  const kind = value?.kind;
  return kind === "space" || kind === "parentParticipants" || kind === "members";
}
__name(isAccessAudience, "isAccessAudience");
function getAccessRoot(doc) {
  const root = doc.accessRoot;
  return typeof root === "string" && root !== "" ? root : void 0;
}
__name(getAccessRoot, "getAccessRoot");
const accessRootProjection = { _id: 1, [ACCESS_ROOT_FIELD]: 1 };
const ACCESS_ROOT_PROJECTION = accessRootProjection;
function getClassAccessPolicy(hierarchy, _class) {
  if (!hierarchy.hasClass(_class)) return void 0;
  return hierarchy.classHierarchyMixin(_class, import_component.default.mixin.ClassAccessPolicy);
}
__name(getClassAccessPolicy, "getClassAccessPolicy");
function getAccessParents(hierarchy, _class) {
  if (!hierarchy.hasClass(_class)) return [];
  return hierarchy.classHierarchyMixin(_class, import_component.default.mixin.AccessParent)?.parents ?? [];
}
__name(getAccessParents, "getAccessParents");
function getAccessAudience(hierarchy, doc) {
  if (!hierarchy.hasMixin(doc, import_component.default.mixin.AccessControlled)) return void 0;
  const read = hierarchy.as(doc, import_component.default.mixin.AccessControlled).read;
  return isAccessAudience(read) ? read : void 0;
}
__name(getAccessAudience, "getAccessAudience");
function getAccessOwners(hierarchy, doc) {
  if (!hierarchy.hasMixin(doc, import_component.default.mixin.AccessControlled)) return [];
  const owners = hierarchy.as(doc, import_component.default.mixin.AccessControlled).owners;
  return Array.isArray(owners) ? owners.filter((it) => typeof it === "string") : [];
}
__name(getAccessOwners, "getAccessOwners");
function touchesAttribute(ops, attribute) {
  const matches = /* @__PURE__ */ __name((key) => key === attribute || key.startsWith(`${attribute}.`), "matches");
  return Object.keys(ops).some(
    (key) => matches(key) || key.startsWith("$") && Object.keys(ops[key] ?? {}).some(matches)
  );
}
__name(touchesAttribute, "touchesAttribute");
function getAccessMembers(doc, policy) {
  const value = doc[policy.membersField];
  return Array.isArray(value) ? value.filter((it) => typeof it === "string") : [];
}
__name(getAccessMembers, "getAccessMembers");
function getAccessReaders(audience, members, parentParticipants) {
  switch (audience.kind) {
    case "space":
      return void 0;
    case "parentParticipants":
      return new Set(parentParticipants ?? []);
    case "members":
      return new Set(members);
  }
}
__name(getAccessReaders, "getAccessReaders");
function getAccessPolicyClasses(hierarchy) {
  let result = policyClasses.get(hierarchy);
  if (result === void 0) {
    result = hierarchy.getDescendants(import_component.default.class.Doc).filter(
      (it) => !hierarchy.isMixin(it) && hierarchy.hasMixin(hierarchy.getClass(it), import_component.default.mixin.ClassAccessPolicy)
    );
    policyClasses.set(hierarchy, result);
  }
  return result;
}
__name(getAccessPolicyClasses, "getAccessPolicyClasses");
const policyClasses = /* @__PURE__ */ new WeakMap();
function resetAccessPolicyClasses(hierarchy) {
  policyClasses.delete(hierarchy);
}
__name(resetAccessPolicyClasses, "resetAccessPolicyClasses");
async function getObjectAccessReaders(hierarchy, find, doc) {
  const rootId = getAccessRoot(doc);
  if (rootId === void 0) return void 0;
  let root = rootId === doc._id ? doc : void 0;
  for (const _class of root === void 0 ? getAccessPolicyClasses(hierarchy) : []) {
    root = (await find(_class, { _id: rootId }, { limit: 1 }))[0];
    if (root !== void 0) break;
  }
  const policy = root !== void 0 ? getClassAccessPolicy(hierarchy, root._class) : void 0;
  if (root === void 0 || policy === void 0 || getAccessRoot(root) !== root._id) return /* @__PURE__ */ new Set();
  const audience = getAccessAudience(hierarchy, root) ?? { kind: "space" };
  let participants;
  const parentId = root[(policy.parent ?? DEFAULT_ACCESS_PARENT).field];
  if (audience.kind === "parentParticipants" && typeof parentId === "string") {
    const collaborators = await find(import_component.default.class.Collaborator, { attachedTo: parentId });
    participants = collaborators.map((it) => it.collaborator);
  }
  return getAccessReaders(audience, getAccessMembers(root, policy), participants);
}
__name(getObjectAccessReaders, "getObjectAccessReaders");
//# sourceMappingURL=objectAccess.js.map
